import Vue from 'vue';
// import OverlayScrollbars from 'overlayscrollbars';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-vue';

Vue.component('overlay-scrollbars', OverlayScrollbarsComponent);

/*
OverlayScrollbars(document.body, {
  nativeScrollbarsOverlaid: {
    initialize: false,
  },
});
*/
